// extracted by css-extract-rspack-plugin
export default {"topContent":"ahb4p","topContentBg":"Gz9l3","content":"a4we2","contentBg":"tCbhv","background":"hpGDT"};